import { create } from "zustand";
import { api } from "./api";

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const useAuthStore = create((set) => ({
  user: undefined, // undefined = checking, null = logged out, object = logged in

  fetchMe: async () => {
    if (!localStorage.getItem("dv_authed")) {
      set({ user: null });
      return;
    }
    try {
      const res = await api.get("/auth/me");
      set({ user: res.data.user });
    } catch {
      localStorage.removeItem("dv_authed");
      set({ user: null });
    }
  },

  login: async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("dv_authed", "1");
    set({ user: res.data.user });
    return res.data.user;
  },

  register: async (email, password, name) => {
    const res = await api.post("/auth/register", { email, password, name });
    localStorage.setItem("dv_authed", "1");
    set({ user: res.data.user });
    return res.data.user;
  },

  logout: async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      localStorage.removeItem("dv_authed");
      set({ user: null });
    }
  },
}));
